/**
 * Created by mzietek on 2016-11-18.
 */

(function (angular) {
    'use strict';

    angular
        .module("repairforms.constant.module")
        .constant("FormInputPossibleErrors", FormInputPossibleErrors());

    function FormInputPossibleErrors() {

        return {
            getPossibleErrors : getPossibleErrors
        };

        function getPossibleErrors() {
            return  {
                MINLENGTH : "minlength",
                REQUIRED : "required",
                PATTERN : "pattern",
                DATEINVALID : "dateinvalid",
                WRONGDATE : "wrongdate",
                MIN : "min",
                MAX : "max",
                MAXLENGTH : "maxlength",
                RESTRICTED : "restriced"
            };
        };

    }

})(angular);